import React, { useContext } from 'react';
import {
  Heading,
  ModalDialog as Modal,
} from 'react-onei';
import styled from 'styled-components';

import spinner from '../../Spinner/spinner.gif';
import UserContext from '../../../context/UserContext';
import device from '../../../helpers/breakpoints';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  widht: 100%;
  height: 100%;
  background-color: #fff;
  padding: 75px;

  @media ${device.mobile} {
    flex-direction: column;
  }
`;

const ModalPassword = ({ isOpen }) => {
  const { wording } = useContext(UserContext);
  const { WLOST_418 } = wording;

  return (
    <Modal
      id="saving-new-password-popin"
      displayed={isOpen}
    >
      <Wrapper>
        <img id="icon-loading" src={spinner} width={60} height={60} alt="Chargement" />
        <Heading as="h4" id="saving-new-password" tabIndex={0} style={{ padding: 15 }}>
            {WLOST_418}
        </Heading>
      </Wrapper>
    </Modal>
  )
};

export default ModalPassword;